import React, { Component } from 'react';
import { connect } from 'react-redux';

import ResetPasswordForm from '../components/Forms/ResetPasswordForm.js';
import LoginChart from '../components/Forms/LoginChart';
import { resetPasswordRequest } from '../actions';

import Logo from './../i/pickaxe.svg'

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.token = window.location.pathname.replace('/password_reset/token/', '')
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit({ password }) {
    const { dispatch } = this.props;

    dispatch(resetPasswordRequest({ token: this.token, password: password }));
  }

  getYear() {
    return new Date().getFullYear()
  }
  render() {

    return (
      <main className="login">
        <section className="login-left">
          <div className="login-beta">
            beta
          </div>
          <div className="login-intro">
            <a href="/" className="d-inline-block mb-5">
              <img src={Logo} alt="Pickaxe" className="login__logo" />
            </a>
            <h1 className="login-intro__title">
              It's your data. We just make it useful.
            </h1>
          </div>
          <div className="login-copyrights">
            @ {this.getYear()} Pickaxe Foundry, Inc
          </div>
        </section>
        <section className="login-right reset-form">
          <ResetPasswordForm onSubmit={this.handleSubmit} />
          <LoginChart />
        </section>
      </main>
    );

  }
}

export default connect()(ResetPasswordPage);
